/** Informations officielles de l'entreprise — source unique pour tout le site. */
export const ENTREPRISE = {
  nom: 'Suro Phone',
  responsable: 'Suren Hovakimyan',
  formeJuridique: 'Entrepreneur individuel',
  siren: '102 106 556',
  siret: '102 106 556 00016',
  tva: 'FR82102106556',
  ape: '9512Z – Réparation d\'équipements de communication',
  adresse: '40 rue de la République, 42400 Saint-Chamond',
  rue: '40 rue de la République',
  cp: '42400',
  ville: 'Saint-Chamond',
  telAffiche: '07 73 60 15 21',
  telLien: 'tel:0773601521',
  whatsapp: 'https://wa.me/33773601521',
  site: 'https://surophone.fr',
  email: 'contact@surophone.fr',
  mapsUrl: 'https://www.google.com/maps/dir//40+rue+de+la+R%C3%A9publique,+42400+Saint-Chamond',
  hebergeur: { nom: 'Emergent', site: 'https://emergent.sh' },
};

export const HORAIRES = [
  { jours: 'Lundi – Vendredi', heures: '10h00 – 18h00' },
  { jours: 'Samedi', heures: '10h00 – 19h00' },
  { jours: 'Dimanche', heures: 'Fermé' },
];

export const HORAIRES_COURT = 'Lun.–ven. 10h–18h · Sam. 10h–19h · Dim. fermé';
export const HORAIRES_PHRASE = 'du lundi au vendredi de 10h00 à 18h00 et le samedi de 10h00 à 19h00 (fermé le dimanche)';
export const RDV_MENTION = 'Sur rendez-vous uniquement';
